export interface UserDisplayNameSource {
    name?: string | null
    first_name?: string | null
    last_name?: string | null
    email?: string | null
    username?: string | null
    phone?: string | null
}

const ANONYMOUS_LABEL = 'Аноним'

export function getDisplayName(source: UserDisplayNameSource | null | undefined): string {
    if (!source) return ANONYMOUS_LABEL

    const name = (source.name?.trim()) || [source.first_name, source.last_name].filter(Boolean).join(' ').trim() || null
    if (name) return name

    const email = source.email?.trim() || null
    if (email) return email

    const username = source.username?.trim() || null
    if (username) return '@' + username

    const phone = source.phone?.trim() || null
    if (phone) return phone

    return ANONYMOUS_LABEL
}
